import { createBaseDtoSchema } from './create-base-dto-schema';

/**
 * The base Data Transfer Object (DTO) schema.
 *
 * This schema is created using the `createBaseDtoSchema` factory function,
 * and serves as the foundational schema for other DTOs in the application.
 *
 * @see createBaseDtoSchema
 */
export const BaseDtoSchema = createBaseDtoSchema();
